import { breakpoints, Card, Column, Columns, Heading, PageBlock, Stack, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useScrollTop } from '../../../common/custom-hooks/scrolling';
import ProgressBar from '../../../common/components/ProgressBar';
import Skeleton from '../../../common/components/Skeleton';

const blockStyles = css`
  background-color: ${vars.colors.page.background.primary};
`;

const travelerCardStyles = css`
  height: 400px;

  @media (min-width: ${breakpoints._970}) {
    height: 764px;
  }
`;

const cartColumnStyles = css`
  display: none;

  @media (min-width: ${breakpoints._970}) {
    display: flex;
    height: 876px;
  }
`;

const TravelerDetailsSkeleton = () => {
  const { t } = useTranslation();

  useScrollTop();

  return (
    <>
      <PageBlock className={blockStyles} withPaddingY>
        <Stack spacing={16}>
          <ProgressBar hasCounter={false} text={t('TravelerDetails.ProgressBar.Text')} />
          <Columns collapseBelow={breakpoints._970}>
            <Column width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '4/6' }}>
              <Card className={travelerCardStyles}>
                <Stack spacing={24}>
                  <Skeleton.Box height={40} width={40} />
                  <Columns spacing={24}>
                    <Column width={{ [breakpoints._0]: '4/4', [breakpoints._768]: '2/4' }}>
                      <Skeleton.Box height={40} />
                    </Column>
                    <Column width={{ [breakpoints._0]: '4/4', [breakpoints._768]: '2/4' }}>
                      <Skeleton.Box height={40} />
                    </Column>
                    <Column width={{ [breakpoints._0]: '4/4', [breakpoints._768]: '2/4' }}>
                      <Skeleton.Box height={40} />
                    </Column>
                    <Column width={{ [breakpoints._0]: '4/4', [breakpoints._768]: '2/4' }}>
                      <Skeleton.Box height={40} />
                    </Column>
                  </Columns>
                </Stack>
              </Card>
            </Column>
            <Column
              className={cartColumnStyles}
              width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '2/6' }}
            >
              <Card>
                <Card.Section>
                  <Heading level={2}>{t('Cart.Title')}</Heading>
                </Card.Section>
                <Card.Section>
                  <Stack>
                    <Skeleton.Box height={40} />
                    <Skeleton.Box height={40} />
                  </Stack>
                </Card.Section>
              </Card>
            </Column>
          </Columns>
        </Stack>
      </PageBlock>
    </>
  );
};

export default TravelerDetailsSkeleton;
